((Drupal, once) => {
  function processLinksForPrint (body) {
    const scope = 'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"])';
    const links = body.querySelectorAll(scope);

    links.forEach((link) => {
      // Remove all classes from links styled like buttons.
      const buttonClasses = ['btn', 'ch-btn', 'ch-microaction-btn'];
      if (buttonClasses.some((className) => link.classList.contains(className))) {
        link.className = '';
      }

      // Create a pretty href attribute for the link.
      const href = link.getAttribute('href');
      let prettyHref = '';
      if (!href.includes('http')) {
        const root = window.location.origin;
        prettyHref = root.replace('https://', '') + href;
      } else {
        prettyHref = href.replace('https://', '');
      }
      link.setAttribute('pretty-href', prettyHref);
    });
  }

  // Drupal is undefined in book-export-html.html.twig, fallback to standard event listener.
  if (Drupal && once) {
    Drupal.behaviors.print = {
      attach (context) {
        if (context !== document) {
          return;
        }
        once('print', 'body', context).forEach((body) => {
          window.addEventListener('beforeprint', () => {
            processLinksForPrint(body);
          });
        });
      },
      detach () {},
    };
  } else {
    window.addEventListener('beforeprint', () => {
      processLinksForPrint(document.body);
    });
  }
})(Drupal || null, once || null);
